import { combineReducers } from "redux";
import auth from "./authentication/authentication.reducer";
import projects from "./projects/projects.reducer";
import comments from './projects/comments.reducer';

export default combineReducers({
  auth,
  projects,
  comments
});
